import Calculator from './lib/Calculator';
import './style/flex.css';
import './style/index.css';
export default Calculator;